import { imalFirebase } from "../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";

export const cloudFns = getFunctions(imalFirebase, "europe-west3");

export const callCloudFn = async (functionName: string, args?: any) =>
  httpsCallable(cloudFns, functionName)(args);
